import React, { useState, useEffect } from 'react';
import { Container, Col, Image, Row } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom'
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import Sidebar from './Sidebar';
import routes from "../routes";
import { Spin as Hamburger } from 'hamburger-react'
import { IPUrl } from '../commons/IPAddress'
import logoname from "../assets/img/logoname.png"

function Header() {
    const [isToggle, setIsToggle] = useState(false);
    const [name, setName] = useState(localStorage.getItem("user_namefamily"));
    const [image, setImage] = useState(localStorage.getItem("user_profile"));
    const UserID = localStorage.getItem("UserId");
    const { pathname } = useLocation()


    const exitHandler = (e) => {
        localStorage.removeItem('UserId');
        localStorage.clear();
    }

    const toggleHandler = () => {
        if (isToggle) setIsToggle(false);
        else setIsToggle(true);
    };

    return <div>
        <header>
            <Container fluid className="rgc-header pt-2">
                {pathname === "/login" ?
                    <Row className='justify-content-center'>
                        <Col xs={12} className="text-center rgc-logo rgc-logo-part">
                            <img src={logoname} alt='' className='mb-2' />
                            <span>خدمات آنلاین شهرداری آمل</span>
                        </Col>
                    </Row>
                    :
                    <Row className='justify-content-center' >

                        <Col xs={6}  className="text-end rgc-logo">
                            <img src={logoname} alt='' />
                        </Col>

                        {/* <Col sm={4} lg={4} className="d-none d-lg-block">
                            <form className="rgc-search mr-5">
                                <input className="form-control me-2 rgc-search"
                                    type="search" placeholder="جستجو..." aria-label="Search" />
                                <i className="fa-light fa-magnifying-glass"></i>
                                <i className='fa fa-search'></i>
                            </form>
                        </Col> */}

                        <Col xs={6} >
                            {UserID === null ?
                                <NavLink to='/login'>
                                    <div className="d-flex nav_logo justify-content-end rgc-profile-header text-white">
                                        <div>
                                            ورود
                                        </div>
                                        <div>
                                            <Avatar size="large" icon={<UserOutlined />} src={image} />

                                        </div>
                                    </div>
                                </NavLink>
                                :
                                <NavLink to='/profile'>
                                    <div className="d-flex nav_logo justify-content-end rgc-profile-header text-white">
                                        <div>
                                            {name}
                                        </div>
                                        <div>
                                            <Avatar size="large" icon={<UserOutlined />} src={image} />
                                        </div>
                                        <div onClick={(e) => exitHandler(e)} className='mt-2'>خروج</div>
                                    </div>
                                </NavLink>
                            }
                        </Col>
                    </Row>
                }

            </Container>
        </header>
        {/* <Sidebar routes={routes} toggle={isToggle} toggleHandler1={toggleHandler} /> */}
    </div>;
}

export default Header;
